import React from 'react'
import styled, { css } from 'styled-components'

const StyledLanguagePicker = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`
StyledLanguagePicker.displayName = 'StyledLanguagePicker'

const LanguageButton = styled(({ chosen, ...rest }) => <button {...rest} />)`
  background: transparent;
  border: 2px solid ${props => props.chosen ? 'var(--color_text_overBgHeader)' : 'transparent'};
  border-radius: 4px;
  color: var(--color_text_overBgHeader);
  padding: 6px 12px;
  height: auto;
  width: auto;
  font-size: 14px;
  font-weight: ${props => props.chosen ? '700' : '500'};

  cursor: ${props => props.chosen ? 'default' : 'pointer'};
  font-variant: all-small-caps;
  text-align: center;
  vertical-align: center;
  transition: all 0.2s ease;

  ${props =>
    !props.chosen
      ? css`
          :hover {
            background: rgba(256, 256, 256, 0.1);
            border-color: var(--color_text_overBgHeader);
          }
        `
      : css`
          cursor: default;
        `}
`
LanguageButton.displayName = 'LanguageButton'

const LanguagePicker = ({ supportedLangs, selectedLang, setSelectedLang }) => {
  return (
    <StyledLanguagePicker>
      {supportedLangs.map(l => (
        <LanguageButton key={l} chosen={l === selectedLang} onClick={() => setSelectedLang(l)}>
          {l}
        </LanguageButton>
      ))}
    </StyledLanguagePicker>
  )
}

export default LanguagePicker
